//更新用户信息
export const UPDATE_USERINFO = 'UPDATE_USERINFO';


// WEBPACK FOOTER //
// ./src/store/userinfo/mutations_types.js